import React from 'react';
import Blogbox from './component/Blogbox';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Blog from './Blog';
// import { blogData } from '../allData/Data';

const Delivery = () => {
    // const limitedBlogData = blogData.slice(0,3);
    return (
        <>
            <Header />
            <div className="TopRedBox">
                <h1>Delivery</h1>
            </div>
            <section className='BlogArea'>
                <div className="container">
                    <div className="row gy-5">
                        <Blogbox 
                        // blogData={limitedBlogData}
                         />
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Delivery;